const scrollToHorizontal = {
    init() {
        const wrapper = document.querySelector('.slider-wrapper');
        const track = document.querySelector('.slider-track');

        if (!wrapper || !track) {

            return;
        }

        let target = 0;
        let ticking = false;

        const clamp = (v, min, max) => Math.max(min, Math.min(max, v));

        const animate = () => {
            ticking = false;

            const max = track.scrollWidth - track.clientWidth;
            target = clamp(target, 0, max);

            const cur = track.scrollLeft;
            const diff = target - cur;

            if (Math.abs(diff) < 0.5) {
                track.scrollLeft = target;

                return;
            }

            track.scrollLeft = cur + diff * 0.15;

            ticking = true;
            window.requestAnimationFrame(animate);
        };

        wrapper.addEventListener('wheel', (e) => {
            if (track.scrollWidth <= track.clientWidth) {

                return;
            }

            let delta = e.deltaY;

            if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
                delta = e.deltaX;
            }

            e.preventDefault();

            target += delta * 1.2;

            if (!ticking) {
                ticking = true;
                window.requestAnimationFrame(animate);
            }
        }, { passive: false });
    }
};

export default scrollToHorizontal;
